import React from "react";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import { GlobalStyles } from "../theme";

interface Props {
  children?: any;
}

const Layout: React.FC<Props> = ({ children }: Props) => {
  return (
    <Container>
      <Helmet>
        <meta charSet="utf-8" />
        <meta httpEquiv="ScreenOrientation" content="autoRotate:disabled" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0, shrink-to-fit=no"
        />
      </Helmet>
      <GlobalStyles />
      {children}
    </Container>
  );
};

export default Layout;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;

  main {
    min-height: inherit;
  }
`;
